import PropTypes from "prop-types"

import PeriodSelectionHOC from "../period_selection_hoc"
import TopCategoryComponent from "./top_category_component"
import topCategoriesFetcher from "./top_categories_fetcher"
import { calculateChangeRate } from "../lib"
import "./top_categories.scss"

const TopCategoriesContainer = ({
  data: { categories },
  serviceName,
  timePeriodInDays,
  categoriesUrl,
  servicesUrl,
  onDetailSelect,
  showPage,
}) => (
  <>
    <div>
      {categories.map((category, index) => (
        <TopCategoryComponent
          categoryName={category.name}
          categoryId={category.id}
          activeUsers={category.activeUsers}
          numberOfServices={category.serviceCount}
          serviceEngagement={category.serviceEngagement}
          topCategoryServices={category.services}
          userChangeRate={calculateChangeRate(
            category.activeUsers,
            category.activeUsersLastPeriod
          )}
          serviceEngagementChangeRate={calculateChangeRate(
            category.serviceEngagement,
            category.serviceEngagementsLastPeriod
          )}
          connectionPercentage={category.connectionPercentage}
          comparisonWindow={timePeriodInDays}
          topServices={category.topServices}
          serviceName={serviceName}
          key={index}
          categoriesUrl={
            categoriesUrl != null ? `${categoriesUrl}/${category.id}` : "#"
          }
          servicesUrl={servicesUrl}
          onDetailSelect={categoriesUrl == null ? onDetailSelect : null}
        />
      ))}
    </div>
    {showPage && (
      <div className="action-buttons-container">
        <a
          role="button"
          className="button-secondary button-outlined"
          href={categoriesUrl}
        >
          View all categories connected
        </a>
      </div>
    )}
  </>
)

TopCategoriesContainer.propTypes = {
  serviceName: PropTypes.string,
  data: PropTypes.object,
  timePeriodInDays: PropTypes.number,
  categoriesUrl: PropTypes.string,
  servicesUrl: PropTypes.string.isRequired,
  onDetailSelect: PropTypes.func,
  showPage: PropTypes.bool,
}

export default PeriodSelectionHOC({
  WrappedComponent: TopCategoriesContainer,
  serviceMetricsFetcher: topCategoriesFetcher,
  headerText: "Categories connected",
  subHeaderText: "The top service categories connected to %SERVICE_NAME%",
  fetchDailyComparisonData: true,
  limit: 4,
})
